import { PlusOutlined } from "@ant-design/icons";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { PATH_CREATE_COUPON_FAMILY, couponFilter } from "@configs";
import { IFormExportValues } from "@interfaces";
import { CouponTable } from "@modules";
import { selectApp } from "@redux";
import {
  getApiErrorMessage,
  useCouponFamilyListPage,
  useExportCoupons,
  useNotify,
} from "@utils";
import { Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ExportSidebar } from "./Export";

export const PageListCoupon = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  const exportCoupons = useExportCoupons();

  const {
    data,
    total,
    page,
    filters,
    date,
    refetch,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
  } = useCouponFamilyListPage();

  const goToCreate = () => history.push(PATH_CREATE_COUPON_FAMILY);

  const handleDownload = async (payload: IFormExportValues) => {
    try {
      const { data: fileData } = await exportCoupons.mutateAsync({
        couponFamilyId: payload.couponFamilyId,
        startDate: payload.date?.[0] ? payload.date[0] : undefined,
        endDate: payload.date?.[1] ? payload.date[1] : undefined,
        active: payload.status?.includes("Active") ? "active" : "",
        expired: payload.status?.includes("Expired") ? "expired" : "",
        redeemed: payload.status?.includes("Redeemed") ? "redeemed" : "",
      });
      const url = window.URL.createObjectURL(new Blob([fileData], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export redeem coupon");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err) {
      error(getApiErrorMessage(err, t("message.download.fail")));
    }
  };

  const button = (
    <Space>
      {mobile ? (
        <Tooltip title={t("page.add_new_coupon_family")}>
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        </Tooltip>
      ) : (
        <>
          <ExportSidebar
            data={data}
            handleExport={(params: IFormExportValues) => handleDownload(params)}
          />
          <Tooltip title={t("page.add_new_coupon_family")}>
            <SharedButton
              type="primary"
              ghost
              icon={<PlusOutlined />}
              size="middle"
              onClick={goToCreate}
            >
              {t("page.add_cf")}
            </SharedButton>
          </Tooltip>
        </>
      )}
    </Space>
  );

  return (
    <>
      <ComponentHeader title={t("page.coupon_management")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={couponFilter}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          {mobile && (
            <Space direction="horizontal">
              <ExportSidebar
                data={data}
                handleExport={(params: IFormExportValues) => handleDownload(params)}
              />
            </Space>
          )}
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <CouponTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
